class Googlemap {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBbVCq0v_2HiHSm8FIdk65_zS5_cflLmjw&callback=initMap';
    script.async = true;

    document.head.appendChild(script);

    window.initMap = function() {

      var map;
      var latLng;
      var marker = [];
      var infoWindow = [];

      function initMap() {
        // 現在地の取得
        navigator.geolocation.getCurrentPosition(function(position) {
          // 緯度経度の取得
          latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          markerPin();
        }, function() {
          latLng = new google.maps.LatLng({
            lat: markerData[0]['lat'],
            lng: markerData[0]['lng']
          }); // 緯度経度のデータ作成
          markerPin();
        });
      }

      function markerPin() {
        var map = new google.maps.Map(document.querySelector('.js-map'), { // #sampleに地図を埋め込む
          center: latLng, // 地図の中心を指定
          // zoom: 13 // 地図のズームを指定
          zoom: 12 // 地図のズームを指定
        });
        // マーカー毎の処理
        for (var i = 0; i < markerData.length; i++) {
          var markerLatLng = new google.maps.LatLng({
            lat: markerData[i]['lat'],
            lng: markerData[i]['lng']
          }); // 緯度経度のデータ作成

          marker[i] = new google.maps.Marker({ // マーカーの追加
            position: markerLatLng, // マーカーを立てる位置を指定
            map: map // マーカーを立てる地図を指定
          });
          infoWindow[i] = new google.maps.InfoWindow({ // 吹き出しの追加
            content: '<div class="sample">' + markerData[i]['name'] + '</div>' // 吹き出しに表示する内容
          });
          markerEvent(i); // マーカーにクリックイベントを追加

          marker[i].setOptions({// TAM 東京のマーカーのオプション設定
            icon: {
              url: markerData[i]['icon']// マーカーの画像を変更
            }
          });
        }
      }

      // マーカーにクリックイベントを追加
      function markerEvent(i) {
        marker[i].addListener('click', function () { // マーカーをクリックしたとき
          infoWindow[i].open(map, marker[i]); // 吹き出しの表示
        });
      }
      initMap();
    }
  }
}